import React from 'react';
type EstimateFormValues = {
  fullName: string;
  phone: string;
  email: string;
};
type EstimateFormProps = {
  onSubmit?: (values: EstimateFormValues) => void;
};
export function EstimateForm({
  onSubmit
}: EstimateFormProps) {
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const values: EstimateFormValues = {
      fullName: String(data.get('fullName') ?? ''),
      phone: String(data.get('phone') ?? ''),
      email: String(data.get('email') ?? '')
    };
    onSubmit?.(values);
  }
  return <form className="space-y-5" onSubmit={handleSubmit} noValidate={false} data-id="element-1">
      <div data-id="element-2">
        <label htmlFor="fullName" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-3">
          Full Name
        </label>
        <input type="text" id="fullName" name="fullName" autoComplete="name" placeholder="John Smith" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brandBlue-500 focus:border-brandBlue-500 transition-colors bg-slate-50 focus:bg-white" required data-id="element-4" />
      </div>

      <div data-id="element-5">
        <label htmlFor="phone" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-6">
          Phone Number
        </label>
        <input type="tel" id="phone" name="phone" autoComplete="tel" placeholder="(555) 123-4567" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brandBlue-500 focus:border-brandBlue-500 transition-colors bg-slate-50 focus:bg-white" required data-id="element-7" />
      </div>

      <div data-id="element-8">
        <label htmlFor="email" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-9">
          Email Address
        </label>
        <input type="email" id="email" name="email" autoComplete="email" placeholder="john@email.com" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-brandBlue-500 focus:border-brandBlue-500 transition-colors bg-slate-50 focus:bg-white" required data-id="element-10" />
      </div>

      <button type="submit" className="w-full bg-brandBlue-600 hover:bg-brandBlue-700 text-white font-bold text-lg py-4 px-6 rounded-xl transition-colors shadow-md flex justify-center items-center gap-2 mt-2" data-id="element-11">
        Request My Free Estimate <span aria-hidden="true" data-id="element-12">&rarr;</span>
      </button>
    </form>;
}